export default __webpack_public_path__ + "static/media/Red0001.8efbe36c.png";